import {ADMIN_API_URL} from '../../../../resources/api';

export const openCloseURL : string = `${ADMIN_API_URL}group/public/${process.env.REACT_APP_GROUP_ID}`;